module.exports = __webpack_public_path__ + "img/summer-showcase-hero.402ebccd.png";